(function() {
    'use strict';

    angular.module('allegro').controller('AllegroResponsibleProducerUpdateController', AllegroResponsibleProducerUpdateController);

    AllegroResponsibleProducerUpdateController.$inject = [
        '$state',
        '$stateParams',
        'notificationSrvc',
        'errorNotificationSrvc',
        'allegroAccountDataSrvc',
        'allegroResponsibleProducersDataSrvc',
        'allegroResponsibleProducerMessagesConst'
    ];

    function AllegroResponsibleProducerUpdateController(
        $state,
        $stateParams,
        notificationSrvc,
        errorNotificationSrvc,
        allegroAccountDataSrvc,
        allegroResponsibleProducersDataSrvc,
        allegroResponsibleProducerMessagesConst
    ){
        var self = this;
        self.loading = false;

        self.serverErrors = {
            account: [],
            name: []
        };

        self.account = {};
        self.responsibleProducerData = {
            account: null,
            name: ''
        };

        self.getAccount = getAccount;
        self.getResponsibleProducerData = getResponsibleProducerData;
        self.updateResponsibleProducer = updateResponsibleProducer;
        self.cleanErrors = cleanErrors;

        active();

        function active(){
            self.loading = true;

            self.getResponsibleProducerData($stateParams.pk).then(function(response) {
                if (response.account) {
                    return self.getAccount(response.account);
                }
            })
            .then(function(data) {
                self.loading = false;
            });
        }

        function getResponsibleProducerData(receiverPk){
            return allegroResponsibleProducersDataSrvc.get({pk: receiverPk})
                .$promise
                .then(function (response) {
                    self.responsibleProducerData = response;
                    return response;
                })
                .catch(function(response) {
                    if (response.status === 404) {
                        notificationSrvc.notification("error", response.data.detail);
                        $state.go('layout.allegro-accounts.list');
                    }
                })
                .finally(function (response) {
                    self.loading = false;
                    return response;
                });
        }

        function getAccount(accountPk) {
            self.loading = true;

            return allegroAccountDataSrvc.get({pk: accountPk})
                .$promise
                .then(function (response) {
                    self.account = response;
                    return response;
                })
                .catch(function(response) {
                    if (response.status === 404) {
                        notificationSrvc.notification("error", response.data.detail);
                        $state.go('layout.allegro-accounts.list');
                    }
                })
                .finally(function (response) {
                    self.loading = false;
                    return response;
                });
        }

        function updateResponsibleProducer() {
            self.loading = true;

            allegroResponsibleProducersDataSrvc.update({pk: self.responsibleProducerData.pk}, self.responsibleProducerData)
                .$promise
                .then(function(response) {
                    notificationSrvc.notification("success", allegroResponsibleProducerMessagesConst.update);
                    $state.go('layout.allegro-accounts.detail.settings', {pk: self.account.pk});
                })
                .catch(function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                })
                .finally(function (response) {
                    self.loading = false;
                    return response;
                });
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }
    }
})();
